import { Spinner } from '@cimplico/components';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useWorkpaperContext } from '../../providers/WorkpaperProvider';
import { useWorksheets } from '../../queries/use-worksheets';
import EmptyStateNew from '../empty-state/EmptyStateNew';
import WorksheetResultItem from './WorksheetResultItem';
import { isNullOrUndefined } from '../../features/new-workpaper/utils';

type WorksheetResultListProps = {
    search: string;
    onNavigate: () => void;
};

function WorksheetResultList({ search, onNavigate }: WorksheetResultListProps): JSX.Element {
    const { id: workpaperId } = useWorkpaperContext();

    const worksheetQuery = useWorksheets({
        page: 1,
        searchQuery: search,
        filterQuery: '',
        sortQuery: 'sort[dir]=asc&sort[field]=name',
    });

    const isLoading = worksheetQuery.isLoading;

    const trialBalanceWorksheets = worksheetQuery.data?.worksheets.filter((ws) => !isNullOrUndefined(ws.account)) ?? [];
    const otherSchedules = worksheetQuery.data?.worksheets.filter((os) => isNullOrUndefined(os.account)) ?? [];

    return (
        <>
            {isLoading && (
                <div className="absolute right-1/2 bottom-1/2 translate-x-1/2">
                    <Spinner />
                </div>
            )}
            {!isLoading && (
                <>
                    {trialBalanceWorksheets.length === 0 && otherSchedules.length === 0 ? (
                        <div className="p-8">
                            <EmptyStateNew titleSize="small" icon={<MagnifyingGlassIcon />} title="No worksheets found" />
                        </div>
                    ) : (
                        <>
                            <ul className="text-sm text-gray-800 my-1">
                                {trialBalanceWorksheets.length !== 0 && (
                                    <>
                                        <h2 className="pb-1 pl-2 border-b">Trial Balance</h2>
                                        {trialBalanceWorksheets.map((ws, idx) => (
                                            <WorksheetResultItem
                                                key={ws.id}
                                                worksheet={ws}
                                                isLastItem={idx === trialBalanceWorksheets.length - 1}
                                                onNavigate={onNavigate}
                                            />
                                        ))}
                                    </>
                                )}
                                {otherSchedules.length !== 0 && (
                                    <>
                                        <h2 className="border-b pt-2 pl-2 pb-1">Other Schedules</h2>
                                        {otherSchedules.map((os, idx) => (
                                            <WorksheetResultItem
                                                key={os.id}
                                                worksheet={os}
                                                isLastItem={idx === otherSchedules.length - 1}
                                                onNavigate={onNavigate}
                                            />
                                        ))}
                                    </>
                                )}
                            </ul>
                        </>
                    )}
                </>
            )}
        </>
    );
}

export default WorksheetResultList;
